import { AvailabilityMap } from '../../../service/types'

export const isSlotAvailable = (instructorId: string, timeSlot: string, availabilityMap: AvailabilityMap): boolean => {
  const hours = availabilityMap[instructorId]
  if (!hours) return false
  const hour = parseInt(timeSlot.split(':')[0], 10)
  return hours.includes(hour)
}

export const isRangeAvailable = (
  instructorId: string,
  startTime: string,
  endTime: string,
  availabilityMap: AvailabilityMap,
): boolean => {
  const hours = availabilityMap[instructorId]
  if (!hours) return false
  const startHour = parseInt(startTime.split(':')[0], 10)
  const endHour = parseInt(endTime.split(':')[0], 10)
  const endMin = parseInt(endTime.split(':')[1], 10)
  const lastNeededHour = endMin > 0 ? endHour : endHour - 1
  for (let h = startHour; h <= lastNeededHour; h++) {
    if (!hours.includes(h)) return false
  }
  return true
}
